import changeCart from '../../lib/changeCart';
import initCartRecommendations from './initCartRecommendations';

const CART_SECTION_SELECTOR = '[data-cart-section]';
const CART_RECOMMENDATIONS_SELECTOR = '[data-cart-recommendations]';

const setLineItemBusy = (containerEl, isBusy) => {
  if (!containerEl) return;
  containerEl.classList.toggle('opacity-50', isBusy);
  containerEl.querySelectorAll('button').forEach((buttonEl) => {
    buttonEl.disabled = isBusy;
  });
};

const syncDecreaseState = (containerEl) => {
  const valueEl = containerEl?.querySelector('[data-cart-qty-value]');
  const decreaseEl = containerEl?.querySelector('[data-cart-qty-decrease]');
  if (!valueEl || !decreaseEl) return;
  decreaseEl.disabled = parseInt(valueEl.textContent, 10) <= 1;
};

const fetchCartSectionEl = async (sectionId) => {
  try {
    const res = await fetch(`${window.Shopify.routes.root}cart?section_id=${sectionId}`);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    return doc.querySelector(CART_SECTION_SELECTOR);
  } catch (err) {
    console.error('Failed to fetch cart section:', err);
    return null;
  }
};

const restoreRecommendations = (sectionEl, previousRecsEl) => {
  const newRecsEl = sectionEl.querySelector(CART_RECOMMENDATIONS_SELECTOR);
  if (!newRecsEl) return;

  if (previousRecsEl?.dataset.url === newRecsEl.dataset.url) {
    newRecsEl.replaceWith(previousRecsEl);
    return;
  }
  initCartRecommendations();
};

const renderCartSection = async (bindEventsFn) => {
  const sectionEl = document.querySelector(CART_SECTION_SELECTOR);
  if (!sectionEl) return false;

  const newSectionEl = await fetchCartSectionEl(sectionEl.dataset.sectionId);
  if (!newSectionEl) return false;

  const previousRecsEl = sectionEl.querySelector(CART_RECOMMENDATIONS_SELECTOR);
  sectionEl.replaceChildren(...newSectionEl.childNodes);
  restoreRecommendations(sectionEl, previousRecsEl);
  bindEventsFn();
  return true;
};

const refreshCart = async (bindEventsFn) => {
  const isRendered = await renderCartSection(bindEventsFn);
  if (!isRendered) window.location.reload();
};

const updateLineQuantity = async (stepperEl, delta, bindEventsFn) => {
  const valueEl = stepperEl.querySelector('[data-cart-qty-value]');
  if (!valueEl) return;

  const newQty = parseInt(valueEl.textContent, 10) + delta;
  if (Number.isNaN(newQty) || newQty < 1) return;

  const lineItemEl = stepperEl.closest('[data-cart-line-item]') || stepperEl;
  setLineItemBusy(lineItemEl, true);

  const result = await changeCart(stepperEl.dataset.cartStepper, newQty);
  if (result) {
    await refreshCart(bindEventsFn);
    return;
  }
  setLineItemBusy(lineItemEl, false);
  syncDecreaseState(lineItemEl);
};

const removeLineItem = async (removeEl, bindEventsFn) => {
  const lineItemEl = removeEl.closest('[data-cart-line-item]') || removeEl;
  setLineItemBusy(lineItemEl, true);

  const result = await changeCart(removeEl.dataset.cartRemove, 0);
  if (result) {
    await refreshCart(bindEventsFn);
    return;
  }
  setLineItemBusy(lineItemEl, false);
  syncDecreaseState(lineItemEl);
};

const bindCartEvents = () => {
  const stepperEls = document.querySelectorAll('[data-cart-stepper]');
  stepperEls.forEach((stepperEl) => {
    const decreaseEl = stepperEl.querySelector('[data-cart-qty-decrease]');
    const increaseEl = stepperEl.querySelector('[data-cart-qty-increase]');

    decreaseEl?.addEventListener('click', () => updateLineQuantity(stepperEl, -1, bindCartEvents));
    increaseEl?.addEventListener('click', () => updateLineQuantity(stepperEl, 1, bindCartEvents));
  });

  const removeEls = document.querySelectorAll('[data-cart-remove]');
  removeEls.forEach((removeEl) => {
    removeEl.addEventListener('click', () => removeLineItem(removeEl, bindCartEvents));
  });
};

const initCartPage = () => {
  bindCartEvents();
};

export default initCartPage;
